export const RETRY_FETCH = 'stores/RETRY_FETCH';

export const DISABLE_STORES = 'stores/DISABLE_STORES';

export const ACTIVATE_STORES = 'stores/ACTIVATE_STORES';
